import React from 'react';
import styled from 'styled-components';
import { Tooltip, PopOut } from 'components'

const defaultStyle = {
    color: 'var(--text-color)',
    backgroundColor: 'transparent',
    fontSize: '0.8rem',
    fontWeight: null,
    size: 'inherit',
    padding: '0.25rem 0.5rem',
    margin: '0.5rem',
    borderColor: 'transparent',
    // hoverColor: 'var(--text-color)',
    boxShadowColor: 'var(--primary-accent2-color)',
    justifyContent: 'center',
    alignItems: 'center',
    brightness: 'var(--brightness)',
    textDecoration: null
    // boxShadowColor: null
}

const iconStyle = {
    color: 'var(--text-color)',
    backgroundColor: 'transparent',
    fontSize: '0.8rem',
    fontWeight: null,
    size: 'inherit',
    padding: '0.5rem',
    margin: '0.5rem',
    borderColor: 'transparent',
    // hoverColor: 'var(--text-color)',
    alignItems: 'center'
}

const Container = styled.div`
    box-sizing: content-box;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    justify-content: ${props => props.styles.justifyContent};
    align-items: ${props => props.styles.alignItems};

    color: ${props => props.styles.color};
    background-color: ${props => props.styles.backgroundColor};
    font-size: ${props => props.styles.fontSize};
    font-weight: ${props => props.styles.fontWeight};
    text-decoration: ${props => props.styles.textDecoration};
    height: ${props => props.styles.height};
    width: ${props => props.styles.width};
    padding: ${props => props.icon ? '0.5rem' : props.styles.padding};
    margin: ${props => props.styles.margin};
    border: ${props => `1px solid ${props.styles.borderColor}`};
    box-shadow: ${props => `0px 2px 1px -1px ${props.styles.boxShadowColor},` + 
                        `0px 1px 1px 0px ${props.styles.boxShadowColor}, ` +
                        `0px 1px 3px 0px ${props.styles.boxShadowColor}`};
    :hover {
        filter: ${props => `brightness(${props.styles.brightness})`};
        color: ${props => props.styles.hoverColor || props.styles.color || 'var(--text-color)'};
    }
    
`

const Wrapper = styled.div`
    margin: ${props => props.margin};
    max-width: ${props => props.maxWidth};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

const IconWrapper = styled.div`
    margin: ${props => props.margin};
    display: flex;
    align-items: center;
    justify-content: center;
`

const Button = (props) => {
    const {
        icon,
        text,
        onSelect,
        onClose,
        onOpen,
        contextMenu,
        onHoverContext,
        tooltip,
        disabled,
        placement,
        styles,
        iconOnly,
        trigger
    } = props;
    const updatedStyle = Object.assign({}, iconOnly ? iconStyle : defaultStyle, styles)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, openPopper] = React.useState(false)
    const clickHandler = (event) => {
        // event.stopPropagation()
        setAnchorEl(anchorEl ? null : event.currentTarget);
        openPopper(!open);
        !open && onClose && onClose()
        open && onSelect && onSelect()
        onOpen && onOpen()
    }

    let popOutElement = null;
    if(contextMenu) {
        popOutElement = React.cloneElement(contextMenu, {closeHandler: clickHandler})
    }

    let mainContent
    if(tooltip){
        mainContent =
        <Tooltip title={tooltip} arrow>
            <Container styles={updatedStyle}
                onClick={contextMenu ? clickHandler 
                        : !disabled && onSelect ? onSelect
                        : null}>
                    {icon && <IconWrapper margin={text && '0 0.5rem 0 0'}>{icon}</IconWrapper>}
                    <Wrapper maxWidth={updatedStyle['maxWidth']}>{text}</Wrapper>
            </Container>
        </Tooltip> 
    } else {
        mainContent = 
        <Container styles={updatedStyle}
            onClick={contextMenu ? clickHandler 
                    : !disabled && onSelect ? onSelect
                    : null}>
            {icon && <IconWrapper margin={text && '0 0.5rem 0 0'}>{icon}</IconWrapper>}
            <Wrapper maxWidth={updatedStyle['maxWidth']}>{text}</Wrapper>
        </Container>
    }

    if(contextMenu){
        return(
            <div>
                <PopOut trigger={trigger || 'leftClick'} placement={placement || 'bottom-start'}  animation='default' element={popOutElement}>
                    {mainContent}
                </PopOut>
            </div>
        )
    } else {
        return(
            <div>{mainContent}</div>
        )
    }
}

export default Button;
